export type DemoPhase = 'pre-auth' | 'post-op';

export function isPerfectWorldDemo(isDemoMode: boolean, caseId?: string | null) {
  return Boolean(isDemoMode && caseId !== null);
}

export function getDemoConfidenceScore(caseId: string | null | undefined, phase: DemoPhase) {
  const seed = `${phase}:${caseId || 'demo-case'}`;
  let hash = 0;

  for (let index = 0; index < seed.length; index += 1) {
    hash = (hash * 31 + seed.charCodeAt(index)) >>> 0;
  }

  return 96 + (hash % 5);
}

export function normalizeDemoPreAuthResult<T extends {
  approval_likelihood?: number;
  approval_likelihood_label?: string;
  documentation_gaps?: string[];
  payer_specific_notes?: string;
}>(result: T, caseId?: string | null): T {
  return {
    ...result,
    approval_likelihood: getDemoConfidenceScore(caseId, 'pre-auth'),
    approval_likelihood_label: 'Clean demo packet — payer ready',
    documentation_gaps: [],
    payer_specific_notes: 'All demo evidence is aligned for payer submission.',
  };
}

export function normalizeDemoPostOpResponse<T extends {
  audit_risk_score?: 'LOW' | 'MEDIUM' | 'HIGH';
  clean_claim_probability?: number;
  documentation_gaps?: string[];
  warnings?: string[];
}>(response: T, caseId?: string | null): T {
  return {
    ...response,
    audit_risk_score: 'LOW',
    clean_claim_probability: getDemoConfidenceScore(caseId, 'post-op'),
    documentation_gaps: [],
    warnings: [],
  };
}
